import { render, staticRenderFns } from "./ProfileVideos.vue?vue&type=template&id=14c99e2f&scoped=true"
import script from "./ProfileVideos.vue?vue&type=script&lang=js"
export * from "./ProfileVideos.vue?vue&type=script&lang=js"
import style0 from "./ProfileVideos.vue?vue&type=style&index=0&id=14c99e2f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c99e2f",
  null
  
)

/* custom blocks */
import block0 from "./ProfileVideos.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports